import { useNavigate, useParams } from "react-router-dom";
import { ErrorState, Loading } from "@/components/States";
import { useAuth } from "@/context/AuthContext";
import { FullScreen, Results, StudySessionView } from "@/pages/student/StudyModeContent";
import { useStudySession } from "@/pages/student/useStudySession";

export default function StudyMode() {
  const { packId } = useParams();
  const navigate = useNavigate();
  const { principal, refresh } = useAuth();
  const language = principal?.preferred_language || "es";
  const study = useStudySession(packId, refresh, language);

  if (study.error && !study.session) {
    return <FullScreen><ErrorState message={study.error} onRetry={() => study.begin()} /></FullScreen>;
  }
  if (!study.session) return <FullScreen><Loading label={language === "en" ? "Preparing your exercises..." : "Preparando tus ejercicios..."} /></FullScreen>;
  if (study.results) {
    return (
      <FullScreen>
        <Results results={study.results} onExtend={study.extend} busy={study.busy} error={study.error} onExit={() => navigate("/s")} language={language} />
      </FullScreen>
    );
  }

  return (
    <FullScreen>
      <StudySessionView study={study} onExit={() => navigate("/s")} language={language} />
    </FullScreen>
  );
}
